var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethodDefault = function SvgPaymentMethodDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.435 19.87C21.8174 19.87 25.37 16.3174 25.37 11.935C25.37 7.55262 21.8174 4 17.435 4C13.0526 4 9.5 7.55262 9.5 11.935C9.5 16.3174 13.0526 19.87 17.435 19.87Z",
    fill: "#CCCCCC"
  })));
};
export default SvgPaymentMethodDefault;